module.exports = __webpack_public_path__ + "img/freccetta_su_small.93d05c87.svg";